//==============================================================
// Component: Login
//==============================================================
//
// Rules:
// 1) No console logs before Login click
// 2) Submit, and if server errors -> capture it
// 3) Friendly UI error; detailed console logs only after click
//
// No renderError() in JSX. No pre-click logs.
//==============================================================

import React, { useState, useEffect, useRef } from 'react';
import { Button, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../css/login.css';
import LogoMain from '../images/Logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/reducers/sessionReducer';

const Login = () => {
    const [user_name, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading, error, user, sessionType } = useSelector((state) => state.session);

    //==============================================================
    // Focus: Auto-focus username on mount
    //==============================================================
    useEffect(() => {
        usernameRef.current?.focus();
    }, []);

    //==============================================================
    // Handler: Login submit
    //==============================================================
    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(loginUser({ user_name, password, session_type: 'main' }));
    };

    //==============================================================
    // Effect: Navigate on successful login
    //==============================================================
    useEffect(() => {
        if (user && sessionType === 'main') {
            navigate('/service-calendar');
        }
    }, [user, sessionType, navigate]);

    return (
        <div className="login-container">
            <form onSubmit={handleLogin}>
                <div className="logo">
                    <Image src={LogoMain} preview={false} style={{ objectFit: 'contain' }} />
                    <span>Vehicle Management System</span>
                </div>
                <div className="form-wrap">
                    <div className="form-item">
                        <label htmlFor="username">Login</label>
                        <input
                            ref={usernameRef}
                            type="text"
                            placeholder="User Name"
                            id="username"
                            value={user_name}
                            tabIndex={1}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="password">Password</label>
                        <input
                            ref={passwordRef}
                            type="password"
                            id="password"
                            placeholder="Password"
                            tabIndex={2}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && <p className="error">{error?.type === 'login' ? error.message : ''}</p>}

                    <Button loading={isLoading} type="primary" htmlType="submit" tabIndex={3}>
                        Login
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default Login;
